<template>
    <v-container class="d-flex flex-column align-center justify-center" style="height: 100vh;">
        <v-row class="align-center justify-center text-center">
            <v-col cols="12" class="mb-4 d-flex flex-column align-center justify-center text-center">
                
                <img width="250px" 
                     v-if="!$store.state.baseLoading && !!$store.state.info.form_icon && $store.state.info.form_icon.length > 5" 
                     :src="$store.state.fileBaseUrl+$store.state.info.form_icon" 
                     class="my-3" 
                     contain />
                
                <img v-else-if="!$store.state.baseLoading" 
                     :src="require('../assets/logo.svg')" 
                     class="my-3" 
                     contain 
                     height="150" />
                
                <template v-if="!$store.state.baseLoading">
                    <h1 class="display-2 font-weight-bold mb-3">
                        {{ $store.state.info.direct_title }}
                    </h1>
                    <h4 v-if="$store.getters.getAuthToken != '' && $store.state.mobile != ''" 
                        class="display-2 font-weight-bold mb-3">
                        {{ $t('splash.welcome_message', { mobile: $store.state.mobile }) }}
                    </h4>
                </template>
                
                <template v-else>
                    <v-progress-linear height="20" 
                                     indeterminate 
                                     color="white" 
                                     class="my-5"
                                     :label="$t('splash.loading')"></v-progress-linear>
                </template>
                
                <v-row class="align-center justify-center mt-10">
                    <v-col class="mb-5" cols="auto">
                        <v-btn :disabled="$store.state.baseLoading" 
                              block 
                              color="amber" 
                              rounded 
                              class="my-4"
                              size="large" 
                              @click="$store.commit('setActivePage', 'booking')">
                            {{ $t('splash.reserve_btn') }}
                        </v-btn>
                        
                        <v-btn v-if="$store.getters.getAuthToken == ''" 
                              :disabled="$store.state.baseLoading" 
                              block 
                              variant="outlined" 
                              rounded 
                              color="on-primary"
                              class="my-4" 
                              size="large" 
                              @click="$store.commit('setLoginDialogStatus', true)">
                            {{ $t('splash.login_btn') }}
                        </v-btn>
                        
                        <v-btn v-else 
                              :disabled="$store.state.baseLoading" 
                              block 
                              variant="outlined" 
                              rounded 
                              class="my-4" 
                              size="large" 
                              @click="$store.commit('setActivePage', 'orders_history');">
                            لیست رزروها
                        </v-btn>
                    </v-col>
                </v-row>
                <div v-if="$store.state.additionalInfo.length > 0" class="d-flex justify-center align-center text-center mt-2 rounded" v-html="$store.state.additionalInfo"></div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: "SplashPage",
    data: () => ({}),
};
</script>